export const TableLabel=({color,icon,label})=>{
    return<span style={{color}}><img className='table-icon' src={icon} width={18} height={18} /><label>{label}</label></span>
}